module.exports = __webpack_public_path__ + "img/amec.3a43c5cb.png";